import React from 'react';
import {Card, Col, Form, Row} from "react-bootstrap";
import FileInput from "../UI/upload/FileInput";
import Required from "../Required";

const CloseProjContent = ({closeData,...rest}) => {
    const {handleCloseDateChange,handleChangeFiles} = {...rest.callbacks}
    return (
        <React.Fragment>
            <div className={'mb-4'}>
                <p className={'mb-4 fw-bolder'}>Если вы действительно хотите закрыть проект, приложите протокол и укажите дату закрытия.</p>
                <Row className="mb-4">
                    <Col md={3}>
                        <Form.Label>Дата закрытия<Required/></Form.Label>
                        <Form.Control
                            value={closeData?.closedOn?.split('T')[0]}
                            required
                            type="date"
                            onChange={(e)=>handleCloseDateChange(e)}
                        />
                    </Col>
                </Row>
                <Row>
                    <Form.Label>Файлы (.pdf)<Required/></Form.Label>
                    <Form.Group as={Col}>
                    <FileInput
                        validExtensions = {['pdf']}
                        required
                        customState
                        isMinio
                        downloadble
                        className={'reportFileForm'}
                        fileList={closeData?.closeFiles ?? []}
                        onFileChange={(newFiles) => {
                            handleChangeFiles(newFiles)
                        }}
                        onDeleteFile={(deleteId) => {
                            handleChangeFiles(closeData.closeFiles.filter(x=>x?.id && x?.id!==deleteId))
                        }}
                    />
                </Form.Group>
                </Row>
            </div>
        </React.Fragment>
    );
};

export default CloseProjContent;
